import { FC } from 'react'
import Page from '@/client/submodules/Page'
import { Featured } from './Featured'
import { ImportantThings } from './ImportantThings'
import { PrintDataDeliveryProps } from './types'

export const PrintDataDelivery: FC<PrintDataDeliveryProps> = ({
  seo,
  header,
  footer,
  content: {
    breadcrumb,
    title,
    description,
    important_things,
    more_infos,
    image_list,
    warning_cards,
    guide,
    guide_full_width,
    finishing_techniques_title,
    finishing,
    pentonetitleleft,
    pentonedescleft,
    pentonetitleright,
    pentonedescright
  }
}) => (
  <Page seo={seo} header={header} footer={footer}>
    <Featured breadcrumb={breadcrumb} title={title} description={description} />
    <ImportantThings
      important_things={important_things}
      guide={guide}
      guide_full_width={guide_full_width}
      more_infos={more_infos}
      image_list={image_list}
      warning_cards={warning_cards}
      finishing_techniques_title={finishing_techniques_title}
      finishing={finishing}
      pentonetitleleft={pentonetitleleft}
      pentonedescleft={pentonedescleft}
      pentonetitleright={pentonetitleright}
      pentonedescright={pentonedescright}
    />
  </Page>
)
